import React, { useState, useEffect, useRef } from 'react';
import './Education.css';

const Education = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const education = [
    {
      id: 1,
      period: '2018 - 2021',
      degree: 'M.Sc. Electrical Engineering, Magna Cum Laude (GPA 96.5)',
      institution: 'Tel Aviv University, Israel',
      details: 'Majoring in Signal & Image Processing, Machine Learning and Computer Vision. Relevant courses: "Advanced Image Processing", "Computer Vision", "Video Processing", "Statistical Machine Learning", "Statistical Signal Processing", "Random Processes", "Optimization", "OFDM-MIMO".',
      thesis: 'Thesis under the supervision of Dr. Tamir Bendory: Improving the Accuracy and Efficiency of multi-reference alignment and cryo-EM algorithms using synchronization.',
      awards: 'Dean of Engineering excellent student grant (2020).'
    },
    {
      id: 2,
      period: '2010 - 2013',
      degree: 'B.Sc. Electrical and Computer Engineering, Summa Cum Laude (GPA 92)',
      institution: 'Ben Gurion University, Israel',
      details: 'Majoring in Computer engineering and Communications theory.',
      project: 'Final project under the supervision of Hugo Guterman: "Cooperation Among Robots" - Optimal Deployment of Ad-Hoc Wi-Fi Network in unknown areas using cooperating robots (Excellent project award).',
      awards: 'Dean of Engineering excellence award (2012), Department of EE excellence award (2010,2013).'
    }
  ];

  return (
    <section id="education" className="education" ref={sectionRef}>
      <div className="container">
        <div className={`education-header ${isVisible ? 'visible' : ''}`}>
          <h2 className="section-title">Education</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">Academic background and achievements</p>
        </div>

        <div className={`education-content ${isVisible ? 'visible' : ''}`}>
          <div className="education-timeline">
            {education.map((edu, index) => (
              <div key={edu.id} className="education-item">
                <div className="education-period">
                  <span className="period-text">{edu.period}</span>
                </div>
                <div className="education-details">
                  <h3 className="education-degree">{edu.degree}</h3>
                  <h4 className="education-institution">{edu.institution}</h4>
                  <p className="education-description">{edu.details}</p>
                  {edu.thesis && (
                    <p className="education-thesis">
                      <strong>Thesis:</strong> {edu.thesis}
                    </p>
                  )}
                  {edu.project && (
                    <p className="education-project">
                      <strong>Final Project:</strong> {edu.project}
                    </p>
                  )}
                  {edu.awards && (
                    <p className="education-awards">
                      <strong>Awards:</strong> {edu.awards}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;